import React, { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import back from "../../back.png";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputComboStawkiWyzMulti from "../../helpers/InputComboStawkiWyzMulti";
import InputComboStawkiWyz from "../../helpers/InputComboStawkiWyz";
import InputComboStawki from "../../helpers/InputComboStawki";



function InvoiceEditMass(props)
{ 

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
    
        ids: props.ids,
        termin_platnosci: null,
        data_wystawienia: null,

        fraza: '',
        p_typy_oplat_id: '_x_',

        operacja: '_x_',
        wartosc: 0.00,

        ilosc: 0.00,
        jm: 'sztuki',
        typ_wlasny: 'Inne',

        info: '',

        odsetki: '0', //0 - nic nie rób, 1 - wyzeruj..
    });


    const [invoices, setInvoices] = useState([]);

    
    const valChangeListener = (filedName, val, correct, msg) => { 
      //   console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);         
         setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );         

         if(filedName == 'p_typy_oplat_id' || filedName == 'fraza' || filedName == 'operacja' )
         {
                var newRow = JSON.parse( JSON.stringify(row) );
                newRow[filedName] = val;
                checkP(newRow);
         }


     }
 
 
  
 
 
     const goNextNew = () => {
         console.log("goNext");
         saveData();
     }


    const onBack = (e) => {
        props.goBack();
    }


    
    const checkP = (xParamRow) => {

  
        props.mainView.setProgress(-2);


    
        fetch( Config.url + '/rest_v1_calc,update_mass_check', {
            method: 'POST', 
            body: JSON.stringify(xParamRow), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                               setInvoices(res.result);
                           
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }


    const saveData = (e) => {

  
        props.mainView.setProgress(-2);


    
        fetch( Config.master + '/rest_v1_calc,update_mass_invoice', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Dane zostały zapisane', "ok" , null); 
                                props.goBack();
                           
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }

    


    const itemsOperacja = [    

        { v: '_x_',   title: 'Nie rób nic' },  
        { v: 'delete',   title: 'Usuń pozycje z dokumentu' },  

        { v: 'plus_ilosc',   title: 'Zwiększ (+) ILOŚĆ o podaną wartość:' },        
        { v: 'minus_ilosc',  title: 'Zmniejsz (-) ILOŚĆ o podaną wartość:' },                        
        { v: 'set_ilosc',  title: 'Ustaw ILOŚĆ na:' },     

        { v: 'plus_cena',   title: 'Zwiększ (+) CENĘ o podaną wartość:' },        
        { v: 'minus_cena',  title: 'Zmniejsz (-) CENĘ o podaną wartość:' },                        
        { v: 'set_cena',  title: 'Ustaw CENĘ na:' },   
    ]; 



    const itemsOperacja2 = [    

        { v: '_x_',   title: 'Nie rób nic' },  
        { v: 'new_item',  title: 'Dodaj jako nową pozycje (+)' },   
        { v: 'delete',   title: 'Usuń pozycje z dokumentu' },   

        { v: 'plus_ilosc',   title: 'Zwiększ (+) ILOŚĆ o podaną wartość:' },        
        { v: 'minus_ilosc',  title: 'Zmniejsz (-) ILOŚĆ o podaną wartość:' },                        
        { v: 'set_ilosc',  title: 'Ustaw ILOŚĆ na:' },     

        { v: 'plus_cena',   title: 'Zwiększ (+) CENĘ o podaną wartość:' },        
        { v: 'minus_cena',  title: 'Zmniejsz (-) CENĘ o podaną wartość:' },                        
        { v: 'set_cena',  title: 'Ustaw CENĘ na:' },   
    ]; 



    
    const itemsJM = [    
        { v: 'godzina', title: 'Godzina' },        
        { v: 'dzień',   title: 'Dzień' },         
        { v: 'sztuki',  title: 'Sztuki' },         
        { v: 'miesiąc', title: 'Miesiąc' },         
    ]; 


    const itemsTyp = [    
        { v: 'Czesne', title: 'Czesne' },        
        { v: 'Wyżywienie',   title: 'Wyżywienie' },         
        { v: 'Inne',  title: 'Inne' },                 
    ]; 


    //console.log("Pozycje", row);


        return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>

                    <h1> Edycja masowa rozliczeń </h1>

                    <div className="form_tab_title red_cg">Wybrano dokumentów do edycji: ({props.ids.length}) </div>   

                    <div className="tip">
                        Ustaw tylko te dane, które chcesz zmienić na wybranych dokumentach. 
                    </div>

                    <form className="eForm bg_center">
                    

                            <div className="form_tab_title">Dane podstawowe (nadrukowane na dokumencie)</div>
                            <div className="form_tab">

                                <div className="form_control">
                                        <div className="fieldName">Data wystawienia </div>
                                        <InputDate   userData={props.userData} value={row.data_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia" placeholder={""} className=' ' req='0'   />
                                 </div>


                                 <div className="form_control">
                                        <div className="fieldName">Data sprzedaży </div>
                                        <InputDate   userData={props.userData} value={row.data_sprzedazy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_sprzedazy" placeholder={""} className=' ' req='1'   />
                                </div>

                                 <div className="form_control">
                                        <div className="fieldName">Termin płatności </div>
                                        <InputDate   userData={props.userData} value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci" placeholder={""} className=' ' req='0'   />
                                 </div>

                            </div>

                             <div className="form_btn">

                                    <div className="btn" onClick={saveData}>Zaktualizuj</div>
                                     &nbsp;
                                    <div className="btn" onClick={onBack}>Wstecz</div>

                            </div>

                            <br/>





                            <div className="form_tab_title">Naliczone odsetki</div>
                            <div className="form_tab">

                                            <div className="form_control"> 
                                                            <div className="fieldName">Co zrobić z odsetkami?</div>                                                       
                                                            <InputCombo items={ [ {v:'0',title:'Pozostaw bez zmian'},   {v:'1',title:'Wyzeruj odsetki jeśli nie zostały jeszcze rozliczone'},   ] } value={row.odsetki} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odsetki"} placeholder={""} className='' req='0'   />  
                                            </div>
                            </div>

                             <div className="form_btn">

                                    <div className="btn" onClick={saveData}>Zaktualizuj</div>
                                     &nbsp;
                                    <div className="btn" onClick={onBack}>Wstecz</div>

                            </div>


                            <br/>





                            

                            <div className="form_tab_title">Zmiana wartości w pozycjach</div>
                            <div className="form_tab">
                              

                                    <div className="form_control filedset_inline">
                                                                                                                                                
                                                   
                                                        <InputComboStawki  mainView={props.mainView}  userData={props.userData} value={row.p_typy_oplat_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_typy_oplat_id" placeholder={""} className='w300' req='0'   />

                                                        <b>lub </b>

                                                        **<InputText   userData={props.userData} value={row.fraza} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"**Fraza: "} className='w300' req='0'   /> 

                                               
                                                                                                  
                                    </div>

                                    <div className="form_split"></div>
                                    <br/>
                                    <div className="form_split"></div>

                                    <div className="form_control"> 
                                        ** Jeżeli podasz frazę np. "czesne" to system przeszuka zaznaczone dokumenty, a dokładniej ich pozycje i zaktualizuje tylko te, w których nazwie znajdzie frazę "czesne".
                                    </div>


                                    <div className="form_split"></div>
                                    <br/><br/>

                                     <div className="form_split"></div>

                                    {
                                        row.p_typy_oplat_id  == '_x_' &&
                                            <div className="form_control"> 
                                                            <div className="fieldName">Operacja</div>                                                       
                                                            <InputCombo items={itemsOperacja} value={row.operacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja"} placeholder={""} className='' req='0'   />  
                                            </div>
                                    }
                                     
                                    {
                                        row.p_typy_oplat_id  != '_x_' &&
                                            <div className="form_control"> 
                                                            <div className="fieldName">Operacja</div>                                                       
                                                            <InputCombo items={itemsOperacja2} value={row.operacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja"} placeholder={""} className='' req='0'   />  
                                            </div>
                                    }

                                    {
                                        (row.operacja == "plus_ilosc" || row.operacja == "minus_ilosc" || row.operacja == "set_ilosc" || row.operacja == "plus_cena" || row.operacja == "minus_cena" || row.operacja == "set_cena" ) &&
                                            <div className="form_control">
                                                        <div className="fieldName">Wartość</div>
                                                        <InputDecimal   userData={props.userData} value={row.wartosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wartosc" placeholder={""} className='' req='0'   />
                                            </div>
                                    }

                                    {
                                        (row.operacja == "new_item"   ) &&
                                        <Fragment>

                                                <div className="form_control"> 
                                                          <div className="fieldName">Rodzaj</div>                                                       
                                                         <InputCombo items={itemsTyp} value={row.typ_wlasny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ_wlasny"} placeholder={""} className='  ' req='0'   />  
                                                </div>

                                                <div className="form_control">
                                                            <div className="fieldName">Ilość</div>
                                                            <InputDecimal   userData={props.userData} value={row.ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ilosc" placeholder={""} className='' req='0'   />
                                                </div>

                                                <div className="form_control"> 
                                                            <div className="fieldName">JM</div>                                                       
                                                            <InputCombo items={itemsJM} value={row.jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm"} placeholder={""} className='  ' req='0'   />  
                                                </div>
                                        </Fragment>                                           
                                    }

                                     
                                     
                                     <br/>

                                    <div className="form_control">
                                                    <div className="fieldName">Info (tekst dodany do nazywy pozycji)</div>
                                                    <InputText   userData={props.userData} value={row.info} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="info" placeholder={""} className='w300' req='0'   />
                                    </div>

                                    <div className="form_tab_title red_cg">Ilość znalezionych do edycji wg. stawki (lub frazy) i wybranej operacji: <h3>{invoices.length}</h3> </div>  


                            </div>

                            <div className="form_btn">

                                    <div className="btn" onClick={saveData}>Zaktualizuj</div>
                                     &nbsp;
                                    <div className="btn" onClick={onBack}>Wstecz</div>

                            </div>


                    </form>
            
        </div>
}

export default InvoiceEditMass;

